import React from "react";
import "./Home.css";
import Hero from "../components/Hero";
import ProductScroll from "../components/ProductScroll";

export default function Home() {
  return (
    <div className="home">
      <Hero />

      <ProductScroll />

      {/* ── Brand story section ── */}
      <section className="home-story">
        <div className="home-story-bg" />
        <div className="home-story-content">
          <span className="section-label">Proudly Pahadi</span>
          <h2>Pure by Nature,<br />Pure by Culture</h2>
          <p>
            Pahadi means pure. It always has. We source India's finest natural
            products and hold every single one to the Pahadi standard — quality
            tested, honestly sourced, nothing hidden. If it doesn't pass, it
            doesn't carry our name.
          </p>
          <a href="/products" className="home-story-btn">Shop All Products</a>
        </div>
      </section>

      {/* ── Why PureJar trust strip ── */}
      <section className="home-trust">
        <div className="home-trust-inner">
          <div className="home-trust-item">
            <svg className="trust-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M12 2l8 3v6c0 5-3.5 8.5-8 10-4.5-1.5-8-5-8-10V5z"/><path d="M9 12l2 2 4-4"/></svg>
            <strong>Quality Tested</strong>
            <p>Every product tasted and approved before it carries our name</p>
          </div>
          <div className="home-trust-item">
            <svg className="trust-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M12 2l8 3v6c0 5-3.5 8.5-8 10-4.5-1.5-8-5-8-10V5z"/><path d="M9 12l2 2 4-4"/></svg>
            <strong>No Preservatives</strong>
            <p>100% natural — nothing added, nothing hidden</p>
          </div>
          <div className="home-trust-item">
            <svg className="trust-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M7 2h10M8 2v2.5M16 2v2.5"/><path d="M6 8a2 2 0 012-2h8a2 2 0 012 2v11a2 2 0 01-2 2H8a2 2 0 01-2-2z"/><path d="M6 12h12"/></svg>
            <strong>Small-Batch</strong>
            <p>Packed fresh, the traditional way</p>
          </div>
          <div className="home-trust-item">
            <svg className="trust-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M1 3h15v13H1z"/><path d="M16 8h4l3 3v5h-7z"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>
            <strong>Pan-India Delivery</strong>
            <p>Shipped via Shiprocket, tracked to your door</p>
          </div>
        </div>
      </section>

    </div>
  );
}